// extracted by mini-css-extract-plugin
module.exports = {"contaier":"App_contaier__28rdz","image":"App_image__3HvYI"};